import { render, staticRenderFns } from "./EditTeamComponent.vue?vue&type=template&id=2cdbe142&"
import script from "./EditTeamComponent.vue?vue&type=script&lang=js&"
export * from "./EditTeamComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports